import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { findNodeHandle } from "react-native";
import PointerEventManager from "./PointerEventManager";
import TouchEventManager from "./TouchEventManager";
import { State } from "../../State";
import { isPointerInBounds } from "../utils";
export var GestureHandlerWebDelegate = /*#__PURE__*/ function() {
    "use strict";
    function GestureHandlerWebDelegate() {
        _class_call_check(this, GestureHandlerWebDelegate);
        _define_property(this, "view", void 0);
        _define_property(this, "gestureHandler", void 0);
        _define_property(this, "eventManagers", []);
    }
    _create_class(GestureHandlerWebDelegate, [
        {
            key: "getView",
            value: function getView() {
                return this.view;
            }
        },
        {
            key: "init",
            value: function init(viewRef, handler) {
                var _this = this;
                if (!viewRef) {
                    throw new Error("Cannot find HTML Element for handler ".concat(handler.getTag()));
                }
                this.gestureHandler = handler;
                this.view = findNodeHandle(viewRef);
                this.view.style["touchAction"] = "none";
                //@ts-ignore This one disables default events on Safari
                this.view.style["WebkitTouchCallout"] = "none";
                var config = handler.getConfig();
                if (!config.userSelect) {
                    this.view.style["webkitUserSelect"] = "none";
                    this.view.style["userSelect"] = "none";
                } else {
                    this.view.style["webkitUserSelect"] = config.userSelect;
                    this.view.style["userSelect"] = config.userSelect;
                }
                this.eventManagers.push(new PointerEventManager(this.view));
                this.eventManagers.push(new TouchEventManager(this.view));
                this.eventManagers.forEach(function(manager) {
                    return _this.gestureHandler.attachEventManager(manager);
                });
            }
        },
        {
            key: "isPointerInBounds",
            value: function isPointerInBounds1(param) {
                var x = param.x, y = param.y;
                return isPointerInBounds(this.view, {
                    x: x,
                    y: y
                });
            }
        },
        {
            key: "measureView",
            value: function measureView() {
                var rect = this.view.getBoundingClientRect();
                return {
                    pageX: rect.left,
                    pageY: rect.top,
                    width: rect.width,
                    height: rect.height
                };
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.eventManagers.forEach(function(manager) {
                    return manager.resetManager();
                });
            }
        },
        {
            key: "tryResetCursor",
            value: function tryResetCursor() {
                var config = this.gestureHandler.getConfig();
                if (config.activeCursor && config.activeCursor !== "auto" && this.gestureHandler.getState() === State.ACTIVE) {
                    this.view.style.cursor = "auto";
                }
            }
        },
        {
            key: "onBegin",
            value: function onBegin() {
            // no-op for now
            }
        },
        {
            key: "onActivate",
            value: function onActivate() {
                var config = this.gestureHandler.getConfig();
                if ((!this.view.style.cursor || this.view.style.cursor === "auto") && config.activeCursor) {
                    this.view.style.cursor = config.activeCursor;
                }
            }
        },
        {
            key: "onEnd",
            value: function onEnd() {
                this.tryResetCursor();
            }
        },
        {
            key: "onCancel",
            value: function onCancel() {
                this.tryResetCursor();
            }
        },
        {
            key: "onFail",
            value: function onFail() {
                this.tryResetCursor();
            }
        }
    ]);
    return GestureHandlerWebDelegate;
}();
